import { HttpMethod } from '../constants/enum';
import HiggsPromise from '../utils/higgsPromise';

/* 登录请求
 * GET请求, data为传递给后台的参数, 其他参数使用请查看HiggsPromise对象
*/
export function getCompany(data) {
    return HiggsPromise({
        url: '/index/search',
        type: HttpMethod.GET,
        data: data
    });
}



// WEBPACK FOOTER //
// ./src/services/common.js